import styled, { css } from 'styled-components';
import addAlpha from 'utils/addAlpha';
import DefaultSelect from 'components/Form/Select';
import { Overline } from 'components/Typography';
import { LabelProps } from './types';

// TODO: TFR-44 move to container group or do not export
// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

// TODO: TFR-45:Select make unique name or do not export
export const Select = styled(DefaultSelect)`
  &:focus-within {
    border: 0.0625rem solid ${({ theme }) => theme.colors.gray3};
  }
  &:hover {
    border: 0.0625rem solid ${({ theme }) => theme.colors.gray3};
  }

  &.MuiInputBase-root {
    border-radius: 0.75rem;
    background-color: ${({ theme }) => theme.colors.navyGreenLight};
    font-weight: 500;
    font-size: 1.1875rem;
    color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.8)};
  }
`;

// TODO: TFR-45:Label make unique name or do not export
export const Label = styled(Overline)<LabelProps>`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
  font-weight: 600;
  letter-spacing: 0.1em;
  margin-bottom: 0.75rem;
  ${({ $disabled }) =>
    $disabled &&
    css`
      color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.2)};
    `}
`;
